import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../Enums/Size.enum';
import { CSSZUser } from '../../Interfaces/CSSZ.interface';
import CSSZSickLeaveCertificateTakeover from './CSSZSickLeaveCertificateTakeover';

interface Props extends BaseModalProps {
	onSubmit: () => void;
	user: CSSZUser;
}

const CSSZSickLeaveCertificateTakeoverModal = ({
	onSubmit,
	user,
	...baseModalProps
}: Props) => {
	return (
		<BaseModal
			{...baseModalProps}
			title={'component.CSSZSickLeaveCertificateTakeover.modalTitle'}
			size={Size.MD}>
			<CSSZSickLeaveCertificateTakeover onSubmit={onSubmit} user={user} />
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateTakeoverModal;
